import { render, staticRenderFns } from "./GlobalSurvey.vue?vue&type=template&id=35c218e1"
import script from "./GlobalSurvey.vue?vue&type=script&lang=js"
export * from "./GlobalSurvey.vue?vue&type=script&lang=js"
import style0 from "./GlobalSurvey.vue?vue&type=style&index=0&id=35c218e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports